import { render } from "./Etc.vue?vue&type=template&id=5b68ed12&scoped=true"
import script from "./Etc.vue?vue&type=script&lang=js"
export * from "./Etc.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5b68ed12"

export default script